import React from 'react';
import { Label } from 'react-bootstrap';
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl';
import { Link } from 'react-router';
// @ts-ignore
import urlMapping from '../app/URLMapping';
import { TEST_STATUS_PASSED, TEST_STATUS_FAILED } from '../../common/types/TestTypes';
import { toSnapshotDate } from './snapshotTimestamp';
import './SnapshotGrid.scss';

export interface Snapshot {
  id: string;
  name: string;
  organisation_id: string;
  flow_id: string;
  sourceFlowInvocation_id?: string;
  lastStatus: string;
  updatedAt?: string;
  expectedOutputPreview?: string;
}

interface Props {
  snapshots: Snapshot[];
  loading?: boolean;
}

class SnapshotGrid extends React.Component<Props & InjectedIntlProps> {
  normalizeSnapshotDate(dateVal?: string | Date | number | null): Date | undefined {
    // Same timestamp domain as the Updated At sort (QA-10 F60).
    return toSnapshotDate(dateVal);
  }

  getStatusLabel(status: string) {
    let bsStyle = 'default';
    if (status === TEST_STATUS_PASSED) bsStyle = 'success';
    if (status === TEST_STATUS_FAILED) bsStyle = 'danger';

    return <Label bsStyle={bsStyle}>{status}</Label>;
  }

  render() {
    const { snapshots, intl, loading } = this.props;

    if (loading) {
      return (
        <div className="snapshot-testing-grid__loading">
          <FormattedMessage defaultMessage="Loading snapshots..." id="snapshotTesting.loading" />
        </div>
      );
    }

    if (!snapshots || snapshots.length === 0) {
      return (
        <div className="snapshot-testing-grid__empty">
          <FormattedMessage defaultMessage="No snapshots found." id="snapshotTesting.noSnapshots" />
        </div>
      );
    }

    return (
      <div className="snapshot-testing-grid" role="table">
        <div role="rowgroup">
        <div className="snapshot-testing-grid__header" role="row">
          <div role="columnheader"><FormattedMessage defaultMessage="Name" id="snapshotTesting.name" /></div>
          <div role="columnheader"><FormattedMessage defaultMessage="Status" id="snapshotTesting.status" /></div>
          <div role="columnheader"><FormattedMessage defaultMessage="Updated At" id="snapshotTesting.updatedAt" /></div>
          <div role="columnheader"><FormattedMessage defaultMessage="Preview" id="snapshotTesting.preview" /></div>
        </div>
        </div>
        <div className="snapshot-testing-grid__body" role="rowgroup">
          {snapshots.map(snapshot => (
            (() => {
              const normalizedUpdatedAt = this.normalizeSnapshotDate(snapshot.updatedAt);

              return (
            <div className="snapshot-testing-grid__row" key={snapshot.id} role="row">
              <div className="snapshot-testing-grid__cell snapshot-testing-grid__cell--name" role="cell">
                <div>{snapshot.name}</div>
                {snapshot.sourceFlowInvocation_id && (
                  <div className="snapshot-testing-grid__invocation-link">
                    <small>
                      <Link to={urlMapping.getUrl('flowInvocations', 'view', {
                        organisation_id: snapshot.organisation_id,
                        flow_id: snapshot.flow_id,
                        id: snapshot.sourceFlowInvocation_id
                      })}>
                        <FormattedMessage defaultMessage="view invocation" id="snapshotTesting.viewInvocationLink" />
                      </Link>
                    </small>
                  </div>
                )}
              </div>
              <div className="snapshot-testing-grid__cell snapshot-testing-grid__cell--status" role="cell">
                {this.getStatusLabel(snapshot.lastStatus)}
              </div>
              <div className="snapshot-testing-grid__cell snapshot-testing-grid__cell--updated" role="cell">
                {normalizedUpdatedAt ? (
                  <span>
                    {intl.formatDate(normalizedUpdatedAt)} {intl.formatTime(normalizedUpdatedAt)}
                  </span>
                ) : '-'}
              </div>
              <div className="snapshot-testing-grid__cell" role="cell">
                <pre className="snapshot-testing-grid__preview">
                  <code>{snapshot.expectedOutputPreview}</code>
                </pre>
              </div>
            </div>
              );
            })()
          ))}
        </div>
      </div>
    );
  }
}

export default injectIntl(SnapshotGrid);
